import {useContext, useState} from "react";
import Presence from "../../../app/config/Presence";
import {directusContext} from "../../../app/DirectusProvider";
import moment from "moment";
import Roles from "../../../app/config/Roles";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const EnfantCoursButton = ({enfantCours}) => {
    const {directus, currentUser} = useContext(directusContext);
    const {t} = useTranslation();
    const [ec] = useState(enfantCours);
    const [statut, setStatut] = useState(Presence.parse(ec.presence));
    const [requestPending, setRequestPending] = useState(false);

    function updateStatut(newStatut) {
        setRequestPending(true);
        toast.dismiss();
        toast.promise(new Promise((resolve, reject) => {
            directus.items("cours_enfant").updateOne(ec.id, {presence: newStatut.value}).then(() => {
                setStatut(newStatut);
                resolve();
            }).catch(() => {
                reject();
            }).finally(() => {
                setRequestPending(false);
            });
        }), {
            pending: t('enfantCoursButton.pending'),
            success: t('enfantCoursButton.success'),
            error: t('enfantCoursButton.error')
        }, {autoClose: 1500})
    }

    function onClick() {
        switch (statut) {
            default:
            case Presence.absent:
                updateStatut(Presence.present)
                break;
            case Presence.present:
                updateStatut(Presence.excuse)
                break;
            case Presence.excuse:
                //Un parent ne peut pas mettre le statut "Absent", que présent ou excusé
                updateStatut(currentUser.role.name === Roles.parent ? Presence.present : Presence.absent);
                break;
        }
    }

    const NOM_ENFANT = `${ec.enfant_id?.prenom ?? ""} ${ec.enfant_id?.nom ?? ""}`;
    // noinspection AllyPlainJsInspection
    const NOM_COURS = `${ec.cours_id?.date ? moment(ec.cours_id?.date, "YYYY-MM-DD").format("DD.MM.YYYY") : ""}${ec.cours_id?.groupe?.nom ? ` – ${ec.cours_id?.groupe?.nom}` : ""}`;
    const ENFANT_NAISSANCE = ec?.enfant_id?.naissance ? moment().diff(ec.enfant_id.naissance, 'years') + " " + t("enfant.age") : "";

    return (
        <div className={`grid grid-cols-12 p-3 rounded-lg shadow-lg relative`}
             style={{background: requestPending ? "#AAA" : statut.color}}
             onClick={requestPending ? null : onClick}>
            {currentUser.role.name !== Roles.parent &&
            <div className={'col-span-2 text-center'}>
                {ec.enfant_id?.bus === true &&
                    <img src={`/static/image/logo/bus.svg`} alt={"bus"} className={"w-full"}
                         style={{maxWidth: "28px"}}/>}
            </div>
            }
            <div className={`col-span-${currentUser.role.name === Roles.parent ? '10' : '8'} leading-7`}>
                {currentUser.role.name === Roles.parent ? NOM_COURS : NOM_ENFANT}
                {currentUser.role.name !== Roles.parent && <span className={"ml-1 text-xs"}>
                    {ENFANT_NAISSANCE ? "(" + ENFANT_NAISSANCE + ")" : null}
                </span>}
            </div>
            <div
                className={`col-auto text-right row-span-2 my-auto font-bold text-lg`}>
                {t(statut.text)[0]}
            </div>

            {currentUser.role.name === Roles.parent &&
                <div className={`col-span-10 text-xs ${requestPending && "filter blur-sm"}`}>
                    {NOM_ENFANT}
                </div>}
        </div>
    );
}

export default EnfantCoursButton;
